import { all, fork, takeEvery } from 'redux-saga/effects';
import { types } from './reducer';
import pagination from '@iso/lib/helpers/pagination';
import TypeService from '@iso/services/SettingsService/WarehouseService/WarehouseService';

function* watchFetchWarehouses() {
    yield takeEvery(
        types.REQUEST_FETCH_WAREHOUSES,
        pagination('warehouses').saga(TypeService),
    );
}

function* paginationSaga() {
    yield all([
        fork(watchFetchWarehouses),
    ]);
}

export default paginationSaga;